// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"706":"8d6fda01","775":"f16a2cb5"}[chunkId] + ".chunk.js";
};